<template>
    <div>
        <h2 class="text-lg leading-6 font-bold text-gray-900">{{$t('pages.dashboard.index.overview')}}</h2>
        <div class="flex flex-wrap">
            <div class="w-full md:w-1/2 xl:w-1/3 p-3">
                <div class="bg-gray-100 border-b-2">
                    <div class="flex flex-row items-center px-5 py-1 bg-gray-200">
                        <div class="flex-1 text-right md:text-center">
                            <span class="font-medium text-xs uppercase">{{$t('pages.dashboard.index.running_auctions')}}</span>
                            <h3 class="font-bold text-3xl">{{runningAuctions}} / {{sumBids}} / {{sumCustomers}}</h3>
                            <span class="font-medium text-xs uppercase">{{$t('pages.dashboard.index.auctions_bids_customers')}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Layout from '@/Shared/Layout';

    export default {
        layout: Layout,
        props: {
            runningAuctions: Number,
            sumBids: Number,
            sumCustomers: Number,
        }
    }
</script>
